/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "../../../../components/MKBox";
import MKTypography from "../../../../components/MKTypography";

// Material Kit 2 React examples
import CenteredBlogCard from "../../../../examples/Cards/BlogCards/CenteredBlogCard";

// Images
import quratedImage from "../../../../assets/images/qurate.png";

const apps = [
  {
    key: "qurated",
    image: quratedImage,
    title: "Qurated",
    description:
      "Our goal for Qurated is to give everyone a chance to rate and review every page on the internet!",
    action: {
      type: "external",
      route:
        "https://chromewebstore.google.com/detail/fppmpjjpkoflmpglcmgdggmmckflakhn?utm_source=item-share-cb",
      color: "info",
      label: "find out more",
    },
  },
];

function OurApps() {
  return (
    <MKBox component="section" py={{ xs: 2, md: 3 }} my={0}>
      <MKTypography variant="h4" color="dark" mb={{ xs: 4, md: 5 }}>
        Our Apps
      </MKTypography>
      <Grid container spacing={3}>
        {apps.map((app) => (
          <Grid item xs={12} sm={6} key={app.key}>
            <CenteredBlogCard
              image={app.image}
              title={app.title}
              description={app.description}
              action={app.action}
            />
          </Grid>
        ))}
      </Grid>
    </MKBox>
  );
}

export default OurApps;
